// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-details-container {
  padding: 1rem;
  background-color: #f4f6f8;
  color: #1f2937;
}
.branch-details-container .branch-main-det {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.branch-details-container .branch-main-det h3 {
  font-size: 1.3rem;
  color: #374151;
}
.branch-details-container .branch-main-det h3 span {
  color: var(--primary-color);
}
.branch-details-container h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #111827;
}
.branch-details-container .empty {
  color: #6b7280;
}
.branch-details-container .member-list {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.branch-details-container .branch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.branch-details-container .members-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}
.branch-details-container .member-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.branch-details-container .member-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.branch-details-container .member-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.branch-details-container .member-name {
  margin: 0;
  font-size: 1.1em;
  font-weight: 600;
}
.branch-details-container .members-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
.branch-details-container .members-table th,
.branch-details-container .members-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.branch-details-container .members-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
.branch-details-container .members-table tr:hover {
  background-color: #f1f3f5;
  cursor: pointer;
}
.branch-details-container .role-badge {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 500;
}
.branch-details-container .member-card {
  cursor: pointer;
  background: #fff;
  border: 1px solid #ddd;
  padding: 1.25rem;
  border-radius: 10px;
}
.branch-details-container .member-card p {
  margin: 0.4rem 0;
  font-size: 0.95rem;
}
.branch-details-container .member-card p strong {
  color: #000;
  margin-right: 0.25rem;
}
.branch-details-container .member-card .role-badge {
  display: inline-block;
  background-color: #d2f8d2;
  color: #267326;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
  text-transform: capitalize;
}
.branch-details-container .loading-msg {
  font-size: 1.1rem;
  text-align: center;
  margin-top: 3rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .branch-details-container {
    padding: 1.5rem;
  }
  .branch-details-container h2 {
    font-size: 1.75rem;
  }
  .branch-details-container h3 {
    font-size: 1.15rem;
  }
  .branch-details-container .member-card {
    padding: 1rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .branch-details-container {
    padding: 1rem;
  }
  .branch-details-container h2 {
    font-size: 1.5rem;
  }
  .branch-details-container h3 {
    font-size: 1rem;
  }
  .branch-details-container .member-card {
    padding: 0.85rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.875rem;
  }
  .branch-details-container .member-card .role-badge {
    font-size: 0.7rem;
  }
}
@media (max-width: 360px) {
  .branch-details-container {
    padding: 0.75rem;
  }
  .branch-details-container h2 {
    font-size: 1.35rem;
  }
  .branch-details-container h3 {
    font-size: 0.95rem;
  }
  .branch-details-container .member-list {
    grid-template-columns: 1fr;
  }
  .branch-details-container .member-card {
    padding: 0.75rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.82rem;
  }
  .branch-details-container .member-card .role-badge {
    font-size: 0.68rem;
    padding: 0.15rem 0.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/BranchDetails/BranchDetails.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAAJ;AAII;EACE,iBAAA;EACA,cAAA;AAFN;AAIM;EACE,2BAAA;AAFR;AAyCI;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;AAvCN;AA4CE;EACE,cAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,gBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AA9CJ;AAiDE;EACE,wCAAA;EACA,2BAAA;AA/CJ;AAkDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhDJ;AAmDE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAjDJ;AAoDE;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AAlDJ;AAqDE;;EAEE,aAAA;EACA,gBAAA;EACA,6BAAA;AAnDJ;AAsDE;EACE,yBAAA;EACA,gBAAA;AApDJ;AAuDE;EACE,yBAAA;EACA,eAAA;AArDJ;AAwDE;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAvDJ;AAgEI;EACE,gBAAA;EACA,kBAAA;AA9DN;AAgEM;EACE,WAAA;EACA,qBAAA;AA9DR;AAkEI;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAhEN;AAoEE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlEJ;;AAsEA;EACE;IACE,eAAA;EAnEF;EAqEE;IACE,kBAAA;EAnEJ;EAsEE;IACE,kBAAA;EApEJ;EAuEE;IACE,aAAA;EArEJ;EAuEI;IACE,iBAAA;EArEN;AACF;AA0EA;EACE;IACE,aAAA;EAxEF;EA0EE;IACE,iBAAA;EAxEJ;EA2EE;IACE,eAAA;EAzEJ;EA4EE;IACE,gBAAA;EA1EJ;EA4EI;IACE,mBAAA;EA1EN;EA6EI;IACE,iBAAA;EA3EN;AACF;AAgFA;EACE;IACE,gBAAA;EA9EF;EAgFE;IACE,kBAAA;EA9EJ;EAiFE;IACE,kBAAA;EA/EJ;EAkFE;IACE,0BAAA;EAhFJ;EAmFE;IACE,gBAAA;EAjFJ;EAmFI;IACE,kBAAA;EAjFN;EAoFI;IACE,kBAAA;IACA,uBAAA;EAlFN;AACF","sourcesContent":[".branch-details-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  color: #1f2937;\n\n\n  .branch-main-det {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n\n\n\n    h3 {\n      font-size: 1.3rem;\n      color: #374151;\n\n      span {\n        color: var(--primary-color);\n      }\n    }\n\n\n\n    // .view-toggle-wrapper {\n    //   display: flex;\n    //   gap: 5px;\n    // }\n\n    // .view-toggle-btn {\n    //   padding: 8px 12px;\n    //   border: 1px solid #ddd;\n    //   background: white;\n    //   cursor: pointer;\n    //   border-radius: 4px;\n    //   display: flex;\n    //   align-items: center;\n    //   justify-content: center;\n    // }\n\n    // .view-toggle-btn.active {\n    //   background: #007bff;\n    //   color: white;\n    //   border-color: #007bff;\n    // }\n\n    // .view-toggle-btn:hover {\n    //   background: #f8f9fa;\n    // }\n\n    // .view-toggle-btn.active:hover {\n    //   background: #0056b3;\n    // }\n\n\n  }\n  \n    h2 {\n      font-size: 1.5rem;\n      margin-bottom: 0.5rem;\n      color: #111827;\n\n\n    }\n\n  .empty {\n    color: #6b7280;\n  }\n\n  .member-list {\n    list-style: none;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  .branch-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  .members-grid {\n    margin-top: 1rem;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n  }\n\n  .member-card {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 16px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .member-card:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n\n  .member-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n  }\n\n  .member-name {\n    margin: 0;\n    font-size: 1.1em;\n    font-weight: 600;\n  }\n\n  .members-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n\n  .members-table th,\n  .members-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .members-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n  }\n\n  .members-table tr:hover {\n    background-color: #f1f3f5;\n    cursor: pointer;\n  }\n\n  .role-badge {\n    background: #007bff;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: 500;\n  }\n\n  .member-card {\n    cursor: pointer;\n    background: #fff;\n    border: 1px solid #ddd;\n    padding: 1.25rem;\n    border-radius: 10px;\n    // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\n    // transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    // &:hover {\n    //   transform: translateY(-2px);\n    //   box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n    // }\n\n    p {\n      margin: 0.4rem 0;\n      font-size: 0.95rem;\n\n      strong {\n        color: #000;\n        margin-right: 0.25rem;\n      }\n    }\n\n    .role-badge {\n      display: inline-block;\n      background-color: #d2f8d2;\n      color: #267326;\n      border-radius: 5px;\n      padding: 0.2rem 0.5rem;\n      font-size: 0.75rem;\n      font-weight: 600;\n      margin-left: 0.5rem;\n      text-transform: capitalize;\n    }\n  }\n\n  .loading-msg {\n    font-size: 1.1rem;\n    text-align: center;\n    margin-top: 3rem;\n    color: #6b7280;\n  }\n}\n\n@media (max-width: 768px) {\n  .branch-details-container {\n    padding: 1.5rem;\n\n    h2 {\n      font-size: 1.75rem;\n    }\n\n    h3 {\n      font-size: 1.15rem;\n    }\n\n    .member-card {\n      padding: 1rem;\n\n      p {\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .branch-details-container {\n    padding: 1rem;\n\n    h2 {\n      font-size: 1.5rem;\n    }\n\n    h3 {\n      font-size: 1rem;\n    }\n\n    .member-card {\n      padding: 0.85rem;\n\n      p {\n        font-size: 0.875rem;\n      }\n\n      .role-badge {\n        font-size: 0.7rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 360px) {\n  .branch-details-container {\n    padding: 0.75rem;\n\n    h2 {\n      font-size: 1.35rem;\n    }\n\n    h3 {\n      font-size: 0.95rem;\n    }\n\n    .member-list {\n      grid-template-columns: 1fr; // fallback to single column\n    }\n\n    .member-card {\n      padding: 0.75rem;\n\n      p {\n        font-size: 0.82rem;\n      }\n\n      .role-badge {\n        font-size: 0.68rem;\n        padding: 0.15rem 0.4rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
